import { footerColumns, footerStatement } from '@/mocks/homeData';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-background-200">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.2fr_2fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-black text-background-50">
                17
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">17黑料网</span>
            </div>
            <p className="mt-4 max-w-sm text-[13px] leading-relaxed text-foreground-600">
              17黑料网是一个去标识化的人物避雷参考站，汇总公开讨论中的人品盘点、脱粉原因与粉丝回踩说法，
              帮你判断谁不值得追，也提醒你少一点情绪，多一点核对。
            </p>

            <dl className="mt-6 flex flex-col gap-2.5">
              {footerStatement.map((item) => (
                <div key={item.label} className="flex items-center gap-3">
                  <dt className="w-20 shrink-0 font-label text-[12px] text-foreground-500">
                    {item.label}
                  </dt>
                  <dd className="font-label text-[12px] text-foreground-800">{item.value}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-sm font-bold text-foreground-950">
                  {column.title}
                </h4>
                <ul className="mt-4 flex flex-col gap-2.5">
                  {column.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#updates"
                        className="font-label text-[13px] text-foreground-600 transition-colors duration-200 hover:text-primary-600"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 rounded-lg border border-foreground-200 bg-background-100 p-5">
          <h4 className="font-heading text-sm font-bold text-foreground-950">免责声明</h4>
          <p className="mt-2.5 text-[12px] leading-relaxed text-foreground-600">
            本站内容均整理自公开讨论与网友投稿，所有人物均以去标识化代号呈现，仅作为浏览与参考之用，
            不构成对任何个人或团体的定性结论。请理性看待讨论内容，不传播未经核实的信息，不对号入座。
            如相关内容存在事实偏差，欢迎通过内容纠错入口反馈，我们会及时复核调整。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-foreground-300/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <span className="font-label text-[12px] text-foreground-600">
            © 2026 17黑料网 · 避雷名单 / 人品盘点 / 脱粉原因 / 谁不值得追
          </span>
          <div className="flex flex-wrap items-center gap-4">
            <span className="flex items-center gap-1.5 font-label text-[12px] text-foreground-600">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-time-line text-sm" />
              </span>
              页面每 30 分钟整理一次
            </span>
            <span className="flex items-center gap-1.5 font-label text-[12px] text-foreground-600">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-shield-check-line text-sm" />
              </span>
              去标识化处理
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}